import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appFocusable]',
})
export class AppFocusableDirective {

  @Output() public onFocusChange = new EventEmitter();

  @HostListener('focus')
  public onFocus(): void {
    this.onFocusChange.emit(true);
  }

  @HostListener('blur')
  public onBlur(): void {
    this.onFocusChange.emit(false);
  }
}
